import { DOCUMENT, registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/nl-BE';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { MenuItem } from 'projects/assist/src/app/_shared/components/layout/sidenav/models/menuItem';
import { AppTemplateComponent } from 'projects/assist/src/app/_template/components/app.component';
import { AuthService } from 'projects/assist/src/app/users/services/auth.service';
import { UserService } from 'projects/assist/src/app/users/services/user.service';
import { environment } from 'projects/assist/src/environments/environment';
import { GlobalVariables } from '../../../assist/src/app/_shared/services/global.service';
import { StartsettingsService } from '../../../assist/src/app/organisation/services/startsettings.service';

registerLocaleData(locale);

export function getBaseUrl() {
  return environment.apiUrl;
}
export function getPublicBaseUrl() {
  return environment.publicApiUrl;
}
export function getLoginUrl() {
  return environment.loginUrl;
}

export function getAppKey() {
  return environment.appKey;
}

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent extends AppTemplateComponent implements OnInit, AfterViewInit {
  global = GlobalVariables;
  title = 'MijnAssist';
  signedIn = false;
  showmessage = false;
  orgKey!: string;

  menuItems: MenuItem[] = [];

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private route: ActivatedRoute,
    private startsettingService: StartsettingsService,
    private userService: UserService,
    private authService: AuthService,
    private config: NgSelectConfig,
    private router: Router,
  ) {
    super(doc);
    super.ngSelectTranslate(config);

    this.global.isWhiteLabelVsvw = doc.location.hostname == "vrijwilligerswerk.be";
    if (this.global.isWhiteLabelVsvw) {
      doc.documentElement.style.setProperty("--primary", "#006C9A");
    } else {
      doc.documentElement.style.setProperty("--primary", "#0061f2");
    }
  }

  ngAfterViewInit(): void { }

  ngOnInit(): void {
    setTimeout(() => {
      this.showmessage = true;
    }, 3000);
  }
}
